<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
            <div class="modal-header-actions">
              <ActionDownload />
              <ActionPrint />
              <button class="modal-close" @click="$emit('close')">
                &times;
              </button>
            </div>
          </div>

          <div class="modal-body">
            <slot name="body"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ActionDownload from '@/components/Action/ActionDownload';
import ActionPrint from '@/components/Action/ActionPrint';

export default {
  name: 'Modal',
  components: {
    ActionDownload,
    ActionPrint,
  },
};
</script>
